import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {TopBarButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/TopBarButton';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

const styles = require('./TopBarPagesButton.less');
const cx = classnames.bind(styles);

export interface ITopBarPagesButtonProps
{
    className?:string;
}

@observer
export class TopBarPagesButton extends React.Component<ITopBarPagesButtonProps, any>
{
    private _handleClick = (event:React.MouseEvent<HTMLElement>) =>
    {
        const {workbenchVisibility} = controllers.ui;

        workbenchVisibility.togglePagesPanelVisibility();
    };

    public render():JSX.Element
    {
        const {workbenchVisibility} = controllers.ui;
        const {className} = this.props;

        const tooltipContent = 'Outline';

        return (
            <TopBarButton
                className={cx('base', className)}
                iconProps={{name: WSPIcons.visualDesigner.topBar.Pages}}
                onClick={this._handleClick}
                isToggledOn={workbenchVisibility.isPagesPanelVisible()}
                tooltipProps={{content: tooltipContent}}
            />
        );
    }
}
